import Joi from "joi";
import formValidationService from "../../../../../../common/utils/validation/form-validation.service";
import FormValidationResult from "../../../../../../common/utils/validation/types/form-validation-result";
import userFormValidationService from "../../../../../../shared/user/user.validation.service";

const validateTaxiCorporation = (
  taxiCorporationUuid: string
): FormValidationResult => {
  const validationSchema = Joi.string().min(1).required();

  return formValidationService.validate(taxiCorporationUuid, validationSchema);
};

const taxiOfficerEditByRailyFormValidationService = {
  validateTaxiCorporation,
  validateFirstName: userFormValidationService.validateFirstName,
  validateLastName: userFormValidationService.validateLastName,
  validatePhoneNumber: userFormValidationService.validateMobile,
  validateAlternativePhoneNumber:
    userFormValidationService.validateAlternativeMobile,
  validateEmail: userFormValidationService.validateEmail,
};

export default taxiOfficerEditByRailyFormValidationService;
